import RedEye from '../3D/RedEye';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Header, { Header_Link } from '../layout/Header';
import DefaultNoScroll from './DefaultNoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import gsap, { Expo, Power2, Power3 } from 'gsap';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';

import WheelControls from '../_app/cuchillo/scroll/WheelControls';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import { DataHolder } from '../DataHolder';
import { Basics } from '../_app/cuchillo/core/Basics';
import CarruselSlider from '../3D/CarruselSlider';
import WebGLSketch from '../_app/cuchillo/3D/WebGLSketch';

export default class Artifacts extends DefaultNoScroll {
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  scroller;
  
  constructor() {
    super();
    Basics.oldPage = "home";
    document.body.classList.add("--remove-footer");
    DataHolder.update();

    this.holder = GetBy.class("__holder", this.container)[0];
    this.texts = GetBy.class("__artifact", this.container);
    this.setupTextSizes();
  }

  setupTextSizes() {
    let maxHeight = 0;
  
    [...this.texts].map(el => {
      const box = el.getBoundingClientRect();
      maxHeight = box.height;
    });

    this.holder.style.setProperty('--offset-v', `${(Metrics.HEIGHT - maxHeight)/this.texts.length+1}px`);
  }

  beforeShow() {
    Header.title.hide();
    super.beforeShow();
  }

  afterShow() {
    super.afterShow();
    CarruselSlider.getInstance().show(this.texts);
  }

  show__effect(__call) {
    Header.mode = "INVERT";
    Wrap.show();

   // WebGLSketch.setTransparentBackground(false);
   // WebGLSketch.enableDOF(true);
    //WebGLSketch.enableBloom(true);
    WebGLSketch.enableFilmGrain(true);

    CarruselSlider.getInstance().show(this.texts);
    CarruselSlider.getInstance().enabled = true;
    
    if (this.isFirstTime) {
      //Preloader.hide(() => { this.afterShow() }); 
      //CarruselSlider.getInstance().preshow();
      Header.show();
      if(__call)  setTimeout(()=> {   __call()}, 4500);
    } else {
      this.afterShow();
    }
  }

  hide__effect() {
    CarruselSlider.getInstance().hide();
    Wrap.hide(() => { this.afterHide() }, {duration:.5});
  }

  beforeHide() {
    document.body.classList.remove("--remove-footer");
    super.beforeHide();
  }
  afterHide() {
    //WebGLSketch.setTransparentBackground(true);
    WebGLSketch.enableDOF(false);
    WebGLSketch.enableFilmGrain(false);

    super.afterHide();
  }

  loop() {
    /*if(this.scroller.total_items > 2) {
      this.scroller.loop();
    }*/

    
  }

  resize() {
    super.resize();
    this.setupTextSizes();
  }
}

ControllerPage._addPage("artifacts", Artifacts)
